export const PAYSLIP = 'PAYSLIP';
export const GET_PAYSLIP_YEAR = `${PAYSLIP}/GET_PAYSLIP_YEAR`;
export const SET_PAYSLIP_YEAR = `${PAYSLIP}/SET_PAYSLIP_YEAR`;
export const GET_PAYSLIP_OVERVIEW = `${PAYSLIP}/GET_PAYSLIP_OVERVIEW`;
export const SET_PAYSLIP_OVERVIEW = `${PAYSLIP}/SET_PAYSLIP_OVERVIEW`;
export const GET_PAYSLIP_DETAIL = `${PAYSLIP}/GET_PAYSLIP_DETAIL`;
export const SET_PAYSLIP_DETAIL = `${PAYSLIP}/SET_PAYSLIP_DETAIL`;
export const GET_FILE_PAYSLIP_DETAIL = `${PAYSLIP}/GET_FILE_PAYSLIP_DETAIL`;
export const EXPORT_PAYSLIP_DETAIL = `${PAYSLIP}/EXPORT_PAYSLIP_DETAIL`;
